module.exports = __webpack_public_path__ + "media/images/client/favicons/icon-160x160-514f9539a0ad587bfb5b25ec4c4263ea.png";